import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hpsfir-card finance" }
const _hoisted_2 = { class: "stat-cards" }
const _hoisted_3 = { class: "stat-value" }
const _hoisted_4 = { class: "stat-value" }
const _hoisted_5 = { class: "stat-value" }
const _hoisted_6 = { class: "stat-value" }

import { ref, onMounted } from 'vue';
import { View, Hide } from '@element-plus/icons-vue';
import dayjs from 'dayjs';
import { useApi } from '@/hooks/useApi';
import BillRecord from './billrecord/index.vue';
import CoinsRecord from './coinsrecord/index.vue';
import PointsRecord from './pointsrecord/index.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const activeTab = ref('billRecord');
const statVisible = ref(false);

const todayIncome = ref('0.00');
const monthIncome = ref('0.00');
const quarterIncome = ref('0.00');
const yearIncome = ref('0.00');

// 获取今日统计
const fetchTodayStats = async() => {
  try {
    const res = await useApi().statisticsApi.getTodayStatisticsstatistics();
    todayIncome.value = res.data.data?.totalIncome || '0.00';
  } catch {
    todayIncome.value = '0.00';
  }
};

// 获取本月统计
const fetchMonthStats = async() => {
  const year = dayjs().year();
  const month = dayjs().month() + 1;
  const periodStr = `${year}-${String(month).padStart(2, '0')}`;
  try {
    const res = await useApi().statisticsApi.getMonthlyIncomestatistics({ year });
    const list = res.data.data || [];
    const current = list.find((item: any) => item.period === periodStr);
    monthIncome.value = current?.income || '0.00';
  } catch {
    monthIncome.value = '0.00';
  }
};

// 获取本季度统计
const fetchQuarterStats = async() => {
  const year = dayjs().year();
  const quarter = Math.ceil((dayjs().month() + 1) / 3);
  const periodStr = `${year}-Q${quarter}`;
  try {
    const res = await useApi().statisticsApi.getQuarterlyIncomestatistics({ year });
    const list = res.data.data || [];
    const current = list.find((item: any) => item.period === periodStr);
    quarterIncome.value = current?.income || '0.00';
  } catch {
    quarterIncome.value = '0.00';
  }
};

// 获取本年统计
const fetchYearStats = async() => {
  const year = dayjs().year();
  const periodStr = String(year);
  try {
    const res = await useApi().statisticsApi.getYearlyIncomestatistics({ startYear: year, endYear: year });
    const list = res.data.data || [];
    const current = list.find((item: any) => item.period === periodStr);
    yearIncome.value = current?.income || '0.00';
  } catch {
    yearIncome.value = '0.00';
  }
};

onMounted(() => {
  fetchTodayStats();
  fetchMonthStats();
  fetchQuarterStats();
  fetchYearStats();
});

return (_ctx: any,_cache: any) => {
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_card, { class: "stat-card" }, {
        default: _withCtx(() => [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "stat-title" }, "今日收入", -1)),
          _createElementVNode("div", _hoisted_3, "¥ " + _toDisplayString(statVisible.value ? todayIncome.value : '****'), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_card, { class: "stat-card" }, {
        default: _withCtx(() => [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "stat-title" }, "本月收入", -1)),
          _createElementVNode("div", _hoisted_4, "¥ " + _toDisplayString(statVisible.value ? monthIncome.value : '****'), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_card, { class: "stat-card" }, {
        default: _withCtx(() => [
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "stat-title" }, "本季度收入", -1)),
          _createElementVNode("div", _hoisted_5, "¥ " + _toDisplayString(statVisible.value ? quarterIncome.value : '****'), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_card, { class: "stat-card" }, {
        default: _withCtx(() => [
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "stat-title" }, "本年收入", -1)),
          _createElementVNode("div", _hoisted_6, "¥ " + _toDisplayString(statVisible.value ? yearIncome.value : '****'), 1)
        ]),
        _: 1
      }),
      _createElementVNode("div", {
        class: "stat-toggle",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (statVisible.value = !statVisible.value))
      }, [
        _createVNode(_component_el_icon, { size: 18 }, {
          default: _withCtx(() => [
            (statVisible.value)
              ? (_openBlock(), _createBlock(_unref(View), { key: 0 }))
              : (_openBlock(), _createBlock(_unref(Hide), { key: 1 }))
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_el_tabs, {
      modelValue: activeTab.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((activeTab).value = $event)),
      class: "finance-tabs"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, {
          label: "支付记录",
          name: "billRecord"
        }, {
          default: _withCtx(() => [
            (activeTab.value === 'billRecord')
              ? (_openBlock(), _createBlock(BillRecord, { key: 0 }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "D币记录",
          name: "coinsRecord"
        }, {
          default: _withCtx(() => [
            (activeTab.value === 'coinsRecord')
              ? (_openBlock(), _createBlock(CoinsRecord, { key: 0 }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "积分记录",
          name: "pointsRecord"
        }, {
          default: _withCtx(() => [
            (activeTab.value === 'pointsRecord')
              ? (_openBlock(), _createBlock(PointsRecord, { key: 0 }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})